import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, STATUS_LABEL, hr, downloadAsBlob, statusBadgeVariant } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Download, FileText } from "lucide-react";

export default function RequestDetail() {
  const { id } = useParams();
  const [r, setR] = useState(null);
  const [audit, setAudit] = useState([]);

  useEffect(() => {
    api.get(`/vacation/requests/${id}`).then(x => setR(x.data));
    api.get(`/audit/${id}`).then(x => setAudit(x.data));
  }, [id]);

  if (!r) return <div className="p-12 text-center">Učitavanje...</div>;

  const downloadPdf = () => {
    downloadAsBlob(`/vacation/requests/${id}/pdf`, `Odluka_GO_${id.slice(0,6)}.pdf`);
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6" data-testid="request-detail">
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <p className="text-sm text-muted-foreground uppercase tracking-wider">Zahtjev</p>
          <h1 className="serif text-3xl font-semibold">{r.employee_name}</h1>
          <p className="text-muted-foreground text-sm">{r.employee_katedra}</p>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={statusBadgeVariant(r.status)} className="text-sm py-1 px-3">{STATUS_LABEL[r.status]}</Badge>
          {(r.status === "decided" || r.status === "sent") && (
            <Button onClick={downloadPdf} variant="outline" data-testid="detail-pdf-btn"><Download className="w-4 h-4 mr-2"/>PDF</Button>
          )}
        </div>
      </div>

      <Card>
        <CardHeader><CardTitle className="text-base">Periodi godišnjeg odmora</CardTitle></CardHeader>
        <CardContent className="space-y-2">
          <div className="flex items-center justify-between p-3 bg-accent/10 rounded">
            <div><span className="font-medium">Kolektivni odmor:</span> {hr(r.collective_start)} – {hr(r.collective_end)}</div>
          </div>
          {r.additional_periods?.map((p,i) => (
            <div key={i} className="flex items-center justify-between p-3 bg-secondary/50 rounded">
              <div><span className="font-medium">Dodatni period {i+1}:</span> {hr(p.start)} – {hr(p.end)}</div>
            </div>
          ))}
          <div className="pt-2 text-sm"><span className="font-medium">Ukupno:</span> {r.total_days} radnih dana</div>
        </CardContent>
      </Card>

      {r.note && (
        <Card><CardHeader><CardTitle className="text-base">Napomena zaposlenika</CardTitle></CardHeader>
          <CardContent><p className="text-sm">{r.note}</p></CardContent></Card>
      )}

      {r.manager_comment && (
        <Card><CardHeader><CardTitle className="text-base">Komentar voditelja</CardTitle></CardHeader>
          <CardContent><p className="text-sm">{r.manager_comment}</p></CardContent></Card>
      )}

      {(r.klasa || r.sharepoint_path) && (
        <Card><CardHeader><CardTitle className="text-base flex items-center gap-2"><FileText className="w-4 h-4"/>Službeni dokument</CardTitle></CardHeader>
          <CardContent className="text-sm space-y-1">
            {r.klasa && <div>KLASA: <code className="bg-secondary px-1.5 py-0.5 rounded">{r.klasa}</code></div>}
            {r.urbroj && <div>URBROJ: <code className="bg-secondary px-1.5 py-0.5 rounded">{r.urbroj}</code></div>}
            {r.sharepoint_path && <div>SharePoint: <code className="bg-secondary px-1.5 py-0.5 rounded">{r.sharepoint_path}</code></div>}
          </CardContent></Card>
      )}

      <Card>
        <CardHeader><CardTitle className="text-base">Povijest</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex justify-between text-sm"><span>Predano</span><span className="text-muted-foreground">{hr(r.created_at)}</span></div>
            {audit.map(a => (
              <div key={a.id} className="flex justify-between text-sm border-l-2 border-accent pl-3">
                <span><span className="font-medium">{a.action}</span> · {a.actor_email} {a.detail && `— ${a.detail}`}</span>
                <span className="text-muted-foreground">{hr(a.timestamp)}</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
